import { render } from "./Atendimento.vue?vue&type=template&id=1474f723&scoped=true"
import script from "./Atendimento.vue?vue&type=script&lang=js"
export * from "./Atendimento.vue?vue&type=script&lang=js"

import "./Atendimento.vue?vue&type=style&index=0&id=1474f723&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/landing-page-telemedicina /node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1474f723"]])

export default __exports__